import React, { useState, useRef } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import styled from 'styled-components';

import SubmitBtn from '../Buttons/SubmitBtn';
import { Azurefunctions } from '@icons-pack/react-simple-icons';

const encode = (data) => {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
};

const ContactForm = ({ lang }) => {
  const data = useStaticQuery(graphql`
    {
      sanityDictionaryGeneral {
        sendButtonText {
          _type
          de
          en
        }
      }
      sanityDictionaryContact {
        nameFieldTitle {
          _type
          de
          en
        }
        nameFieldErrorMsg {
          _type
          de
          en
        }
        emailFieldTitle {
          _type
          de
          en
        }
        emailFieldErrorMsg {
          _type
          de
          en
        }
        subjectFieldTitle {
          _type
          de
          en
        }
        subjectFieldErrorMsg {
          _type
          de
          en
        }
        messageFieldTitle {
          _type
          de
          en
        }
        messageFieldErrorMsg {
          _type
          de
          en
        }
        requiredMessage {
          _type
          de
          en
        }
      }
    }
  `);
  return (
    <Formik
      initialValues={{ fullName: '', email: '', subject: '', message: '' }}
      validate={(values) => {
        let errors = {};

        if (!values.fullName) {
          errors.fullName =
            data.sanityDictionaryContact.requiredMessage.de &&
            data.sanityDictionaryContact.requiredMessage.en
              ? data.sanityDictionaryContact.requiredMessage[lang]
              : 'Pflichtfeld';
        } else if (values.fullName.length <= 4) {
          errors.fullName =
            data.sanityDictionaryContact.nameFieldErrorMsg.de &&
            data.sanityDictionaryContact.nameFieldErrorMsg.en
              ? data.sanityDictionaryContact.nameFieldErrorMsg[lang]
              : 'Name muss mindestens 5 Zeichen lang sein';
        }

        if (!values.email) {
          errors.email =
            data.sanityDictionaryContact.requiredMessage.de &&
            data.sanityDictionaryContact.requiredMessage.en
              ? data.sanityDictionaryContact.requiredMessage[lang]
              : 'Pflichtfeld';
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
          errors.email =
            data.sanityDictionaryContact.emailFieldErrorMsg.de &&
            data.sanityDictionaryContact.emailFieldErrorMsg.en
              ? data.sanityDictionaryContact.emailFieldErrorMsg[lang]
              : 'Ungültige Emailadresse';
        }

        if (!values.subject) {
          errors.subject =
            data.sanityDictionaryContact.requiredMessage.de &&
            data.sanityDictionaryContact.requiredMessage.en
              ? data.sanityDictionaryContact.requiredMessage[lang]
              : 'Pflichtfeld';
        } else if (values.subject.length <= 3) {
          errors.subject =
            data.sanityDictionaryContact.subjectFieldErrorMsg.de &&
            data.sanityDictionaryContact.subjectFieldErrorMsg.en
              ? data.sanityDictionaryContact.subjectFieldErrorMsg[lang]
              : 'Betreff muss mindestens 4 Zeichen lang sein';
        }

        if (!values.message) {
          errors.message =
            data.sanityDictionaryContact.requiredMessage.de &&
            data.sanityDictionaryContact.requiredMessage.en
              ? data.sanityDictionaryContact.requiredMessage[lang]
              : 'Pflichtfeld';
        } else if (values.message.length <= 9) {
          errors.message =
            data.sanityDictionaryContact.messageFieldErrorMsg.de &&
            data.sanityDictionaryContact.messageFieldErrorMsg.en
              ? data.sanityDictionaryContact.messageFieldErrorMsg[lang]
              : 'Nachricht muss mindestens 10 Zeichen lang sein';
        }

        return errors;
      }}
      onSubmit={(values, actions) => {
        console.log(values);
        fetch('/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: encode({
            'form-name': 'contact-form',
            ...values,
          }),
        })
          .then(() => {
            alert('send');
            actions.resetForm();
          })
          .catch((error) => alert(error))
          .finally(() => actions.setSubmitting(false));
      }}
    >
      <StyledForm netlify-honeypot="bot-field" data-netlify="true" name="contact-form">
        <Field type="hidden" name="form-name" />
        <Field type="hidden" name="bot-field" />

        <div className="form-group">
          <label htmlFor="fullName">
            {data.sanityDictionaryContact.nameFieldTitle.de &&
            data.sanityDictionaryContact.nameFieldTitle.en
              ? data.sanityDictionaryContact.nameFieldTitle[lang]
              : 'Name'}
          </label>
          <Field name="fullName" type="text" placeholder="" className="form-control" />
          <ErrorMessage name="fullName">
            {(msg) => <StyledInvalidFeedback>{msg}</StyledInvalidFeedback>}
          </ErrorMessage>
        </div>

        <div className="form-group">
          <label htmlFor="email">
            {data.sanityDictionaryContact.emailFieldTitle.de &&
            data.sanityDictionaryContact.emailFieldTitle.en
              ? data.sanityDictionaryContact.emailFieldTitle[lang]
              : 'Email'}
          </label>
          <Field name="email" type="email" placeholder="" className="form-control" />
          <ErrorMessage name="email">
            {(msg) => <StyledInvalidFeedback>{msg}</StyledInvalidFeedback>}
          </ErrorMessage>
        </div>

        <div className="form-group">
          <label htmlFor="subject">
            {data.sanityDictionaryContact.subjectFieldTitle.de &&
            data.sanityDictionaryContact.subjectFieldTitle.en
              ? data.sanityDictionaryContact.subjectFieldTitle[lang]
              : 'Betreff'}
          </label>
          <Field name="subject" type="text" placeholder="" className="form-control" />
          <ErrorMessage name="subject">
            {(msg) => <StyledInvalidFeedback>{msg}</StyledInvalidFeedback>}
          </ErrorMessage>
        </div>

        <div className="form-group">
          <label htmlFor="message">
            {data.sanityDictionaryContact.messageFieldTitle.de &&
            data.sanityDictionaryContact.messageFieldTitle.en
              ? data.sanityDictionaryContact.messageFieldTitle[lang]
              : 'Nachricht'}
          </label>
          <Field name="message" as="textarea" placeholder="" className="form-control" rows="4" />
          <ErrorMessage name="message">
            {(msg) => <StyledInvalidFeedback>{msg}</StyledInvalidFeedback>}
          </ErrorMessage>
        </div>

        <StyledSubmitBtnContainer>
          <SubmitBtn
            type="submit"
            btnText={
              data.sanityDictionaryGeneral.sendButtonText.de &&
              data.sanityDictionaryGeneral.sendButtonText.en
                ? data.sanityDictionaryGeneral.sendButtonText[lang]
                : 'Absenden'
            }
            withText
          />
        </StyledSubmitBtnContainer>
      </StyledForm>
    </Formik>
  );
};

const StyledInvalidFeedback = styled.div`
  color: ${(props) => props.theme.colors.warning};
  font-size: 80%;
  font-weight: 300;
  margin-top: 0.25rem;
`;

const StyledForm = styled(Form)`
  margin-top: 2rem;

  & label {
    font-weight: 400;
  }

  & .form-control {
    border-radius: 0;
  }
`;

const StyledSubmitBtnContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 1.5rem 0 0;
`;

export default ContactForm;
